import React from 'react';
import { Typography, Tag } from 'antd';
import dayjs from 'dayjs';
import { useQuery } from '@tanstack/react-query';
import blogService from '../../../services/lichvietweb/blogServiceRequest';
import CrudPage from '../../../components/common/CrudPage';
import useDebounce from '../../../hooks/useDebounce';

const { Text } = Typography;

const QuanLyDanhMuc = () => {
  const [selectSearch, setSelectSearch] = React.useState('');
  const debouncedSelectSearch = useDebounce(selectSearch, 500);

  const filterFields = [
    {
      label: 'Trạng thái',
      value: 'status',
      options: [
        { label: 'Tất cả trạng thái', value: '' },
        { label: 'Đang hoạt động', value: '1' },
        { label: 'Đang bị khóa', value: '0' },
      ],
    },
  ];

  // Fetch categories for Parent Category selection with remote search
  const { data: catData, isFetching } = useQuery({
    queryKey: ['categoryListOptions', debouncedSelectSearch],
    queryFn: () => blogService.search({ search: debouncedSelectSearch, limit: 20 }),
    enabled: true,
  });

  const categoryOptions = React.useMemo(() => {
    // Navigate through response structure to find the array
    const rawList = catData?.data?.list || catData?.list || catData?.data || [];
    return Array.isArray(rawList) ? rawList.map((item) => ({ label: item.name, value: item.id })) : [];
  }, [catData]);

  const categoryFields = React.useMemo(
    () => [
      {
        name: 'name',
        label: 'Tên danh mục',
        type: 'input',
        rules: [{ required: true }],
        placeholder: 'Ví dụ: Văn khấn, Cẩm nang...',
      },
      {
        name: 'slug',
        label: 'Slug (Đường dẫn)',
        type: 'input',
        rules: [{ required: true }],
        placeholder: 'Ví dụ: van-khan',
      },
      {
        name: 'place',
        label: 'Vị trí (Thứ tự hiển thị)',
        type: 'number',
        rules: [{ required: true }],
        propsInput: { min: 0, className: 'w-full' },
      },
      {
        name: 'parent_id',
        label: 'Danh mục cha',
        type: 'select',
        placeholder: 'Chọn danh mục cha (nếu có)',
        options: categoryOptions,
        propsInput: {
          showSearch: true,
          filterOption: false, // Tắt lọc local để dùng remote search
          onSearch: (val) => setSelectSearch(val),
          loading: isFetching,
          allowClear: true,
        },
      },
      {
        name: 'status',
        label: 'Trạng thái',
        type: 'select',
        options: [
          { label: 'Hoạt động', value: 1 },
          { label: 'Khóa', value: 0 },
        ],
        defaultChecked: 1,
      },
    ],
    [categoryOptions, isFetching]
  );

  const columns = [
    {
      title: 'TÊN DANH MỤC',
      dataIndex: 'name',
      key: 'name',
      render: (text) => <Text strong>{text}</Text>,
    },
    {
      title: 'SLUG',
      dataIndex: 'slug',
      key: 'slug',
      render: (text) => <Tag color="blue">{text}</Tag>,
    },
    {
      title: 'DANH MỤC CHA',
      dataIndex: 'parentName',
      key: 'parentName',
      render: (text) => (text ? <Tag color="cyan">{text}</Tag> : <Text type="secondary">-</Text>),
    },
    {
      title: 'VỊ TRÍ',
      dataIndex: 'place',
      key: 'place',
      align: 'center',
    },
    {
      title: 'TRẠNG THÁI',
      dataIndex: 'status',
      key: 'status',
      render: (status) => <Tag color={status === 1 ? 'green' : 'red'}>{status === 1 ? 'HOẠT ĐỘNG' : 'KHÓA'}</Tag>,
    },
    {
      title: 'NGÀY TẠO',
      dataIndex: 'create_time',
      key: 'create_time',
      render: (time) => (time ? dayjs(time).format('DD/MM/YYYY HH:mm') : '-'),
    },
  ];

  return (
    <CrudPage
      title="QUẢN LÝ DANH MỤC"
      subTitle="Quản lý cấu trúc chuyên mục bài viết Lịch Việt Web"
      itemsName="Danh mục"
      queryKey="categoryList"
      service={blogService}
      columns={columns}
      formFields={categoryFields}
      filterFields={filterFields}
      searchPlaceholder="Tìm kiếm tên danh mục, slug..."
      addButtonLabel="Thêm danh mục"
    />
  );
};

export default QuanLyDanhMuc;
